import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OpsDatePickerComponent } from './ops-date-picker.component';

@NgModule({
  declarations: [OpsDatePickerComponent],
  imports: [CommonModule, TranslateModule],
  exports: [OpsDatePickerComponent],
})
export class OpsDatePickerModule {}
